import { http } from '@/services'

export const authService = {
    signup: (firstname, lastname, email, password) => {
        return http.post('account/jwtsignup', {
                firstName: firstname,
                lastName: lastname,
                email: email,
                password: password
            })
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    confirm: (email, code) => {
        return http.post('account/jwtconfirmsignup', {
                email: email,
                verifyCode: code
            })
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    resend: (email) => {
        return http.post('account/jwtresend', {
                email: email
            })
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    forgotPassword: (email) => {
        return http.post('account/jwtforgotpassword', {
                email: email
            })
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    confirmPassword: (email, code, password) => {
        return http.post('account/jwtconfirmforgotpassword', {
                email: email,
                verifyCode: code,
                password: password
            })
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    login: (email, password) => {
        return http.post('account/jwtlogin', {
                email: email,
                password: password
            })
            .then(response => {
                return response.data.token;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    logout: () => {
        if (localStorage.userToken) {
            return http.post('account/jwtlogout')
                .then(response => {
                    return response.data;
                }, error => {
                    return Promise.reject(error && error.response ? error.response : error);
                });
        } else {
            return Promise.resolve();
        }
    },
    changePassword: (email, oldPassword, newPassword) => {
        return http.post('account/jwtchangepassword', {
                email: email,
                oldPassword: oldPassword,
                newPassword: newPassword
            })
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    refreshToken: (email) => {
        return http.post('account/jwtrefreshtoken', {
                email: email
            })
            .then(response => {
                console.log('AuthSvc[token]:', JSON.stringify(response.data));
                return response.data.token;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    checkLicense: () => {
        return http.get('account/payment/license')
            .then(response => {
                console.log('AuthSvc[license]:', JSON.stringify(response.data));
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    checkCoupon: (coupon) => {
        if (coupon && coupon.length > 0) {
            let params = { couponCode: coupon };
            if (localStorage.hmAffiliate && localStorage.hmAffiliate.length > 0) params.affiliate = localStorage.hmAffiliate;

            return http.get('account/coupon/valid', { params: params })
                .then(response => {
                    if (response.data && response.data.isValid) {
                        localStorage.hmCoupon = coupon;
                    } else {
                        delete localStorage.hmCoupon;
                    }
                    return response.data;
                }, error => {
                    return Promise.reject(error && error.response ? error.response : error);
                });
        } else {
            delete localStorage.hmCoupon;
            return Promise.resolve({ isValid: true });
        }
    },
    getPackages: (coupon, workforce) => {
        let params = {};
        if (localStorage.hmAffiliate && localStorage.hmAffiliate.length > 0) params.affiliate = localStorage.hmAffiliate;
        if (localStorage.hmCoupon && localStorage.hmCoupon.length > 0) params.couponCode = localStorage.hmCoupon;
        if (coupon) params.couponCode = coupon;
        if (workforce) params.workforce = workforce;

        return http.get('account/packages', { params: params })
            .then(response => {
                return Promise.resolve(response.data);
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    payment: (token, packageId, args) => {
        let body = { token: token, packageId: packageId, stripe: args }
        if (localStorage.hmAffiliate) body.affiliate = localStorage.hmAffiliate;
        if (localStorage.hmCoupon) body.couponCode = localStorage.hmCoupon;

        return http.post('account/payment', body)
            .then(response => {
                return Promise.resolve(response.data);
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getUser: () => {
        return http.get('account/user')
            .then(response => {
                return Promise.resolve(response.data);
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    setUser: (user) => {
        return http.put('account/user', user)
            .then(response => {
                return Promise.resolve(response.data);
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    submitFeedback: (msg, user, route) => {
        return http.post('account/feedback', {
                msg: msg,
                user: user,
                url: route.fullPath,
                view: route.name
            })
            .then(response => {
                return Promise.resolve(response.data);
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    }
};